/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class ExternalSimplePayService extends __BaseService {
  static readonly getApiExternalSimplePaySuccessPaymentPath = '/api/ExternalSimplePay/SuccessPayment';
  static readonly getApiExternalSimplePayFailPaymentPath = '/api/ExternalSimplePay/FailPayment';
  static readonly getApiExternalSimplePayCancelPaymentPath = '/api/ExternalSimplePay/CancelPayment';
  static readonly getApiExternalSimplePayTimeoutPaymentPath = '/api/ExternalSimplePay/TimeoutPayment';
  static readonly postApiExternalSimplePayIpnPath = '/api/ExternalSimplePay/Ipn';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param id undefined
   */
  getApiExternalSimplePaySuccessPaymentResponse(id?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ExternalSimplePay/SuccessPayment`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  getApiExternalSimplePaySuccessPayment(id?: string): __Observable<null> {
    return this.getApiExternalSimplePaySuccessPaymentResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  getApiExternalSimplePayFailPaymentResponse(id?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ExternalSimplePay/FailPayment`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  getApiExternalSimplePayFailPayment(id?: string): __Observable<null> {
    return this.getApiExternalSimplePayFailPaymentResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  getApiExternalSimplePayCancelPaymentResponse(id?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ExternalSimplePay/CancelPayment`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  getApiExternalSimplePayCancelPayment(id?: string): __Observable<null> {
    return this.getApiExternalSimplePayCancelPaymentResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  getApiExternalSimplePayTimeoutPaymentResponse(id?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ExternalSimplePay/TimeoutPayment`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  getApiExternalSimplePayTimeoutPayment(id?: string): __Observable<null> {
    return this.getApiExternalSimplePayTimeoutPaymentResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @return Success
   */
  postApiExternalSimplePayIpnResponse(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/ExternalSimplePay/Ipn`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @return Success
   */
  postApiExternalSimplePayIpn(): __Observable<string> {
    return this.postApiExternalSimplePayIpnResponse().pipe(
      __map(_r => _r.body as string)
    );
  }
}

module ExternalSimplePayService {
}

export { ExternalSimplePayService }
